<div class="widget-notes-editor">
  <textarea
    [froalaEditor]="options"
    [froalaModel]="content"
    (froalaModelChange)="onContentChange($event)"
  ></textarea>
</div>
